import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const useValidateResetLinkQuery = () => {
  const { mutateAsync, isLoading } = useMutation((linkId: string) => api.get<{ valid?: boolean }>(API_URL.PASSWORD_RESET_VALIDATION, {
    params: {
      link_id: linkId, 
    },
  }));

  return {
    validateResetLinkQuery: mutateAsync,
    isResetLinkValidation: isLoading,
  };
};

export default useValidateResetLinkQuery;
